var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notifications',{staticClass:"mg-notify",attrs:{"group":"default","position":"bottom right","width":"500px","animationName":"notify-show-animation"}})}
var staticRenderFns = []

export { render, staticRenderFns }